import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import * as React from 'react';
import {useState} from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import {
  CATEGORIES,
  CONTENT_LANGUAGES,
  NUMBER_OF_ATTEMPTS,
  POLL_AND_QUIZ_SUBTYPE,
  PUZZLE_DIFFICULTY_LEVEL,
  QUESTION_TYPES,
  RESULTS_VISIBILITY
} from '../constants/appConstants';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import DeleteIcon from '@mui/icons-material/Delete';
import Chip from '@mui/material/Chip';
import PollDropdown from '../components/forms/PollDropdown';
import Typography from '@mui/material/Typography';
import PollSwitch from '../components/forms/PollSwitch';
import {MobileDatePicker} from '@mui/x-date-pickers/MobileDatePicker';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {useNavigate, useSearchParams} from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import PollTextField from '../components/forms/PollTextField';
import CommonAppbar from '../components/common/CommonAppbar';
import {Autocomplete} from '@mui/material';
import {getHastags} from '../utils/helper';
import {faker} from '@faker-js/faker';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import MyEditor2 from '../components/MyEditor2';
import {styled} from '@mui/material/styles';
import ImageBasedPoll from '../components/createPollComponents/ImageBasedPoll';
import ImageIcon from '@mui/icons-material/Image';
import DeveloperInfo from '../components/common/DeveloperInfo';
import {SpinAWheelInputList, WordSearchInputList} from '../components/forms/WordSearchInputList';
import {CREATE_FIELDS, CREATE_FIELDS_BY_Q_TYPE} from '../constants/createConstants';
import Card from '@mui/material/Card';
import puzzle_solved from '../static/images/questionImages/jigsaw_puzzle_solved.png';
import CancelIcon from '@mui/icons-material/Cancel';
import MinAndMax from '../components/forms/MinAndMax';
import CrosswordQuestionAndAnswerInput from '../components/forms/CrosswordQuestionAndAnswerInput';
import SubTypeSelection from '../components/forms/SubTypeSelection';
import FormLabel from '@mui/material/FormLabel';
import WordleInput from '../components/forms/WordleInput';
import CountryCheckbox from '../components/forms/CountryCheckbox';
import CrossMath from './crossMath';
import { CrossMathGridSelection, CrossMathInput } from '../components/forms/CrossMathForm';
import CrossMathPuzzle from './crossMath/answers';
import ImageWordInput from '../components/forms/ImageWordInput';

const {
  TITLE,
  DESCRIPTION,
  OPTION_TYPE,
  IMAGE,
  ALLOW_MANUAL_ENTER_OPTIONS,
  ALLOW_SELECTION_OF_MULTIPLE_OPTIONS,
  CATEGORY,
  CHANGE_VOTES,
  CLICK_TO_VOTE,
  CONTENT_LANGUAGE_SELECTION,
  DIFFICULTY,
  DISABLE_NOTOFICATION,
  EXPLANATION,
  HASHTAGS,
  HIDE_OPTIONS_ON_LOAD,
  IMAGE_2,
  OPTIONS,
  RANDOMIZE_OPTIONS,
  NUMBER_OF_ATTEMPTS_FIELD,
  PRIVATE_QUESTION,
  RESULTS_VISIBILITY_FIELD,
  SCHEDULE,
  VOTES_VISIBILITY,
  TIMERS,
  HINT,
  ATTEMPTS,
  WORDSEARCH_INPUT,
  CROSSWORD_INPUT,
  SPIN_WHEEL_INPUT,
  MIN_MAX,
  WORDLE_INPUT,
  WORDLE_NUMBER_OF_WORDS,
  COUNTRY,
  CROSS_MATH,
  CROSS_MATH_GRID,
  IMAGE_WORD_PUZZLE_INPUT
} = CREATE_FIELDS;

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
export default function CreatePolls() {

  const [showDesc, setShowDesc] = useState(false)
  const [showMainImage, setShowMainImage] = useState(false)
  let [searchParams, setSearchParams] = useSearchParams();
  const selectedPollType = searchParams.get('selectedPollType') || QUESTION_TYPES.POLL
  const [options, setOptions] = useState(['', ''])
  const [hashtags, setHashtags] = useState([])
  const [hashtagInput, setHashtagInput] = useState('')
  const [schedulePoll, setSchedulePoll] = useState(false)
  const [subType, setSubType] = useState(POLL_AND_QUIZ_SUBTYPE.TEXT)
  const isImageBased = subType !== POLL_AND_QUIZ_SUBTYPE.TEXT
  const navigate = useNavigate();
  const visibleFields = CREATE_FIELDS_BY_Q_TYPE[selectedPollType] || CREATE_FIELDS_BY_Q_TYPE[QUESTION_TYPES.POLL];
  console.log("visibleFields1", visibleFields, selectedPollType);

  const isEdit = searchParams.get('edit') === 'true'


  const toggleDesc = () => {
    setShowDesc(!showDesc)
  }

  const handleAddOption = (isAdd, removeIndex) => {
    const optionsTemp = [...options]
    if (isAdd) {
      optionsTemp.push('')
    } else {
      optionsTemp.splice(removeIndex, 1)
    }

    setOptions(optionsTemp)
  }

  const handleHastagDelete = (removeIndex) => {
    const hashtagsTemp = [...hashtags]
    hashtagsTemp.splice(removeIndex, 1)
    setHashtags(hashtagsTemp)
  }

  const handleOptionChange = (value, index) => {
    const optionsTemp = [...options]
    optionsTemp[index] = value
    setOptions(optionsTemp)
  }

  const addItemToArray = (array, newItem) => {
    const arrayClone = [...array]
    arrayClone.push(newItem)
    return arrayClone
  }

  const moreSettingAccordion = () => {
    return <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>More settings</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {visibleFields.includes(RANDOMIZE_OPTIONS) && <PollSwitch label={'Randomize options'}/>}
          {visibleFields.includes(PRIVATE_QUESTION) && <PollSwitch label={'Private Poll'}/>}
          {visibleFields.includes(VOTES_VISIBILITY) && <PollSwitch label={'Votes visibility'}/>}
          {visibleFields.includes(CHANGE_VOTES) && <PollSwitch label={'Change vote'}/>}
          {visibleFields.includes(DISABLE_NOTOFICATION) && <PollSwitch label={'Disable notification'}/>}
          {visibleFields.includes(CLICK_TO_VOTE) && <PollSwitch label={'Click to vote'}/>}
          {visibleFields.includes(HIDE_OPTIONS_ON_LOAD) && <PollSwitch label={'Hide options on load'}/>}
          {visibleFields.includes(RESULTS_VISIBILITY_FIELD) &&
            <PollDropdown label={'Results visibility'} object={RESULTS_VISIBILITY}
                          selectedVal={RESULTS_VISIBILITY.PUBLIC_AFTER_VOTE}/>}
          {visibleFields.includes(ATTEMPTS) &&
            <PollDropdown label={'Number of attempts'} object={NUMBER_OF_ATTEMPTS}/>}
          {visibleFields.includes(TIMERS) && (
            <>
              <Stack direction={'row'}>
                <PollSwitch label={'Timer'}/>
                <TextField
                  required
                  type="number"
                  id="outlined-required"
                  label="Seconds Min 120 seconds(Required)"
                  defaultValue="120"
                />
              </Stack>
            </>
          )}

        </AccordionDetails>
      </Accordion>
    </>
  }

  const renderHashtag = () => {
    return <div>
      {hashtags.map((hashtag, index) => {
        return <Chip label={hashtag} variant="outlined" onDelete={() => handleHastagDelete(index)}/>
      })}
      <>
        <FormControl variant="outlined" fullWidth={true}>
          {/*<InputLabel htmlFor="outlined-adornment-hashtag">Hashtag</InputLabel>*/}
          <Autocomplete
            fullWidth={true}
            id="free-solo-demo"
            freeSolo
            options={getHastags()}
            renderInput={(params) => (
              <TextField {...params} label="Hashtag" onKeyDown={({key}) => {
                if (key === 'Enter') {
                  setHashtags(addItemToArray(hashtags, faker.commerce.product()))
                  setHashtagInput('')
                }
              }}
              />)}
          />
        </FormControl>
      </>
    </div>
  }

  const renderTitle = () => {
    return <Box component="form">
      <TextField
        multiline
        required
        id="outlined-required"
        label="Question/Title"
        defaultValue=""
        fullWidth
        InputProps={{
          endAdornment: <InputAdornment position="start">0/100</InputAdornment>,
        }}
      />
      {visibleFields.includes(DESCRIPTION) && (<>
        {!showDesc && <Button size="small" startIcon={<AddIcon/>} onClick={toggleDesc}>
          Add description
        </Button>
        }
      </>)}

      {visibleFields.includes(CROSS_MATH) && (
        <>
        <CrossMathGridSelection />
        <CrossMathInput />
        </>
      )}



      {visibleFields.includes(IMAGE) && (<>
        <Button component="label" variant="text" startIcon={<ImageIcon/>}>
          Add image
          <VisuallyHiddenInput type="file" onChange={() => {
            setShowMainImage(true)
          }}/>
        </Button>
      </>)}

      {(visibleFields.includes(IMAGE_2) && !showMainImage) && (<>
        <Card sx={{height: 100, marginLeft: 1, borderWidth: 0.5, borderColor: 'black', borderStyle: 'double'}}>
          <Typography align={'center'} sx={{paddingTop: 5}}>
            <Button component="label" variant="contained" startIcon={<ImageIcon/>}>
              Add image
              <VisuallyHiddenInput type="file" onChange={() => {
                setShowMainImage(true)
              }}/>
            </Button>
          </Typography>
        </Card>
      </>)}


      <Stack>
        {showMainImage && <>
          <div style={{position: 'relative'}}>
            <img
              style={{'max-width': '200px', 'border': '2px solid grey'}}
              src={puzzle_solved}
              alt={''}
              loading="lazy"
            />
            <IconButton aria-label="Remove image" sx={{position: 'absolute', left: '165px'}}
                        onClick={() => setShowMainImage(false)}>
              <CancelIcon sx={{fontSize: 30}}/>
            </IconButton>
          </div>
        </>}
      </Stack>

      {showDesc && <>
        <Typography variant={'subtitle2'}>
          Description
        </Typography>
        <MyEditor2/>
      </>}

    </Box>
  }

  const renderSchedulePoll = () => {
    return <><PollSwitch label={`Schedule ${selectedPollType}`} handleChange={(schedule) => {
      setSchedulePoll(schedule)
    }}/>
      {schedulePoll && <>
        <Typography>
          Start Date
          <MobileDatePicker defaultValue={new Date()}/>
        </Typography>
        <Typography>
          End Date
          <MobileDatePicker defaultValue={new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}/>
        </Typography>
      </>}
    </>
  }

  const renderOptionText = ({inputId, optionNumber, option, index}) => {
    return <FormControl sx={{m: 1}} variant="outlined">
      <InputLabel htmlFor={inputId}>{optionNumber}</InputLabel>
      <OutlinedInput
        id={inputId}
        type={'text'}
        value={option}
        label={optionNumber}
        onChange={({target}) => handleOptionChange(target.value, index)}
        endAdornment={
          <InputAdornment position="end">
            0/100
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => handleAddOption(false, index)}
              edge="end"
            >
              <DeleteIcon/>
            </IconButton>

          </InputAdornment>
        }
      />
    </FormControl>
  }

  const renderTextBasedOption = () => {
    return <FormControl sx={{m: 1}} variant="outlined">
      {options.map((option, index) => {
        const optionNumber = `option ${index + 1}`
        const inputId = `outlined-adornment-${index}`
        return <> {
          selectedPollType === QUESTION_TYPES.POLL ?
            renderOptionText({inputId, optionNumber, option, index})
            : <Stack spacing={2} direction={'row'} sx={{mb: 1}}>
              {index === 1 ? <CheckCircleOutlineIcon/> : <PanoramaFishEyeIcon/>}
              {renderOptionText({inputId, optionNumber, option, index})}
            </Stack>
        }
        </>
      })}
    </FormControl>
  }


  return <>
    <CommonAppbar isMainPage={false}
                  pageHeader={`${isEdit ? `Edit ${selectedPollType}` : `Create ${selectedPollType}`}`}/>

    <Box
      component="form"
      sx={{
        width: '95%',
        '&': {m: 1},
      }}
      autoComplete="off"
    >
      <Stack spacing={1}>
        {renderTitle()}
        {visibleFields.includes(OPTION_TYPE) && <SubTypeSelection setSubType={setSubType} subType={subType} />}

        {visibleFields.includes(OPTIONS) &&
          <Stack direction={'column'}>
            {isImageBased ? <ImageBasedPoll options={options}/> : renderTextBasedOption()}
            <Button size="small" startIcon={<AddIcon/>} onClick={() => handleAddOption(true)}>
              Add option
            </Button>
            {visibleFields.includes(EXPLANATION) &&
              <PollTextField label={'Explanation(Optional)'} placeholder={'Optional'}/>}
          </Stack>
        }
        {visibleFields.includes(WORDSEARCH_INPUT) && <WordSearchInputList/>}
        {visibleFields.includes(IMAGE_WORD_PUZZLE_INPUT) && <ImageWordInput/>}
        
        {visibleFields.includes(CROSSWORD_INPUT) && <>
          <DeveloperInfo>Min 5 clues/answers are required. Max 15.</DeveloperInfo>
          <CrosswordQuestionAndAnswerInput/>
        </>}
        {visibleFields.includes(SPIN_WHEEL_INPUT) && <SpinAWheelInputList/>}
        {visibleFields.includes(MIN_MAX) && <MinAndMax/>}
        {visibleFields.includes(CATEGORY) &&
          <PollDropdown label={'Category'} object={CATEGORIES}/>}

        {/*Wordle related*/}
        {visibleFields.includes(WORDLE_NUMBER_OF_WORDS) && <WordleInput /> }

        {visibleFields.includes(DIFFICULTY) &&
          <PollDropdown label={'Difficulty level'} object={PUZZLE_DIFFICULTY_LEVEL}/>}
        {visibleFields.includes(COUNTRY) && <CountryCheckbox />}
        
        {HASHTAGS && <div>{renderHashtag()}</div>}
        {visibleFields.includes(HINT) && (<TextField
          id="hint"
          label="Hint(Optional)"
          fullWidth={true}
          InputProps={{
            endAdornment: <InputAdornment position="start">0/100</InputAdornment>,
          }}
        />)}

        {visibleFields.includes(SCHEDULE) && (renderSchedulePoll())}

        {visibleFields.includes(ALLOW_MANUAL_ENTER_OPTIONS) && (
          <PollSwitch label={'Allow manually enter option'}/>)}
        {visibleFields.includes(ALLOW_SELECTION_OF_MULTIPLE_OPTIONS) && (
          <PollSwitch label={'Allow selection of multiple options'}/>)}

        {moreSettingAccordion()}
        <DeveloperInfo> Validate form before create </DeveloperInfo>
        <Button variant="contained" onClick={() => navigate(`/polls/${selectedPollType}?success=true`)}>
          {isEdit ? 'Update' : 'Create'}
        </Button>
      </Stack>
    </Box>
  </>
}
